import { styled } from "styled-components";
import { MobileMenu } from "../../Components/NavBar/NavBar";
import { Landing } from "./Sections/Landing/Landing";
import { Conversation } from "./Sections/Conversation/Conversation";
import { Footer } from "./Sections/Footer/Footer";

const HomeContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    width: 100vw;
    overflow-x: hidden;
    overflow-y: scroll;
    z-index: 1;
    top: 0;
    left: 0;
    caret-color: transparent;
    margin: 0;
    padding: 0;
    background: ${(props) => props.theme.colors.background};
    transition: ${(props) => props.theme.animationTime.short}s all ease;
`;

export const Home = () => {
    return (
        <HomeContainer>
            <MobileMenu />
            <Landing />
            <Conversation />
            <Footer />
        </HomeContainer>
    );
};
